import React, { Component } from 'react'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer'
import './css/index.css'
import Grid from '../../components/grid/grid2'
import Grid3 from '../../components/grid/grid3'
import {data_event} from '../../dummy/data_event'
import HeadPage from '../../components/header'
import {Link} from 'react-router-dom'
import {TextField,Select,MenuItem,Button,CircularProgress,FormControl,InputLabel,OutlinedInput} from '@material-ui/core'
import axios from 'axios'
import {URL,USER,PASS} from '../../service/base_url'
import {get} from 'lodash'
import Modal from '../../components/modal'
import ModalFilterEvent from '../../components/modal/filter_event'
import moment from 'moment'
import Download from './download_insight'
import {connect} from 'react-redux'
import {getEvent} from '../../redux/action/event'
import Skeleton  from 'react-loading-skeleton';
import ChevronRight from '../../assets/image/chevron-right.svg'
import { DirectLink, Element, Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'
import general from '../../redux/reducer/general'

import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
class index extends Component {
    state={
        request_form:false,
        success_form:false,
        photoIndex: 0,
        isOpen: false,
        title:'',
        name:'',
        phoneNumber:'',
        email:'',
        companyName:'',
        loading:false,
        webinar:[],
        event:[],
        timeout:true,
        webinar_filter_date:null,
        event_filter:false,
        event_filter_list:{
            category:0,
            date:null,
            location:0
        },
        is_event_filter:false,
        is_webinar_filter:false,
    }
    async componentDidMount(){
        
        await this.props.getEvent()
        setTimeout(()=>{
            this.setState({timeout:false})
        },3000)

    }
    componentDidUpdate(){
        if(this.state.timeout===false){
            scroller.scrollTo(window.location.hash.substr(1), {
                duration: 800,
                delay: 0,
                smooth: 'easeInOutQuart'
              })
        }
    }
    componentWillReceiveProps(newProps){
        const {list_event}=newProps.event
        let webinar=[],event=[]
        if(list_event!==null){
            list_event.map((data,i)=>{
                if(data.webEvent.categoryId===1||data.webEvent.categoryId===2){
                    event.push(data)
                }else{
                    webinar.push(data)
                }
            })
            this.setState({webinar,event})
        }
        
    }
    toggleRequest=(title)=>{
        this.setState({request_form:!this.state.request_form,title:title})
    }
    toggleSucces=()=>{
        window.open(`/${this.state.title}`,'Download')
        this.setState({success_form:!this.state.success_form})
    }
    sendForm=()=>{
        this.setState({request_form:false,success_form:true})
    }
    onChange=(e)=>{
        e.preventDefault()
        this.setState({[e.target.name]:e.target.value})
    }
    submit=(e)=>{
        e.preventDefault()
        this.setState({loading:true})
        let {name,phoneNumber,email,companyName,title}=this.state
        axios.post(`${URL}`,{
            name,phoneNumber,email,companyName,action:`insight-${title}`
        },{
            auth: {
                username: USER,
                password: PASS
              }
        }).then((res)=>{
            if(get(res,'status')==200){
                

                this.setState({loading:false})
               
                this.setState({success_form:!this.state.success_form,request_form:!this.state.request_form})
            }else{
                this.setState({loading:false})
                alert('Ops something error')
            }
        })
    }
    children=()=>{
        let {loading}=this.state
        return(
            <div>
                <p>Please fill out the form below to request a copy of insight</p>
                <br/>
                <form onSubmit={this.submit}>
                <FormControl variant="outlined" size="small"  className='form-request'>
                    <InputLabel  htmlFor="name">Name<span style={{color:'red'}}>*</span></InputLabel>
                    <OutlinedInput
                        
                        id="name"
                        type='text'
                        name='name'
                        onChange={this.onChange}
                        required
                        labelWidth={70}
                    />
                </FormControl>
                <br/><br/>
               
                 <FormControl variant="outlined" size="small"  className='form-request'>
                    <InputLabel  htmlFor="email">Email<span style={{color:'red'}}>*</span></InputLabel>
                    <OutlinedInput
                        
                        id="email"
                        type='email'
                        name='email'
                        onChange={this.onChange}
                        required
                        labelWidth={70}
                    />
                </FormControl>
                <br/><br/>
               {/* asd */}
                <FormControl variant="outlined" size="small"  className='form-request'>
                    <InputLabel  htmlFor="phoneNumber">Phone No.<span style={{color:'red'}}>*</span></InputLabel>
                    <OutlinedInput
                        
                        id="phoneNumber"
                        type='number'
                        name='phoneNumber'
                        onChange={this.onChange}
                        required
                        labelWidth={80}
                    />
                </FormControl>
                <br/><br/>
                
                <FormControl variant="outlined" size="small"  className='form-request'>
                    <InputLabel  htmlFor="companyName">Company name<span style={{color:'red'}}>*</span></InputLabel>
                    <OutlinedInput
                        
                        id="companyName"
                        type='companyName'
                        name='companyName'
                        onChange={this.onChange}
                        required
                        labelWidth={120}
                    />
                </FormControl>
                
                
                <br/><br/>
                <Button type='submit' style={{textTransform:'none',width:100}} size="small" color="primary" variant="contained">
                    {loading? <CircularProgress size={20} style={{color:'white'}}/>:'Send'}
                </Button>
                </form>
            </div>
        )
    }
    onApplyEvent=(e,p)=>{
        let {startDate,endDate}=p
        this.setState({event_filter_list:{...this.state.event_filter_list,date:{startDate,endDate}}})
    }
    onApply=(e,p)=>{
        let {startDate,endDate}=p
        let only_webinar=this.props.event.list_event.filter((data)=>{
            return data.webEvent.categoryId!==1&&data.webEvent.categoryId!==2
        })
        this.setState({webinar_filter_date:{startDate,endDate}})
        let new_webinar=[]
        only_webinar.map((data)=>{
            let isBetwen=moment(data.webEvent.fromDate).isBetween(startDate,endDate)
            if(isBetwen){
                new_webinar.push(data)
            }
        })
        this.setState({webinar:new_webinar,is_webinar_filter:true})
    }
    onCancelWebinar=()=>{
        let only_webinar=this.props.event.list_event.filter((data)=>{
            return data.webEvent.categoryId!==1&&data.webEvent.categoryId!==2
        })
        this.setState({webinar:only_webinar,webinar_filter_date:null})
    }
    onCancelEvent=()=>{
        let only_event=this.props.event.list_event.filter((data)=>{
            return data.webEvent.categoryId===1||data.webEvent.categoryId===2
        })
        this.setState({event:only_event,event_filter_list:{...this.state.event_filter_list,date:null}})
    }
    onSaveFilterEvent=()=>{
        
        let {date,category,location}=this.state.event_filter_list
        let new_event=[]
        let only_event=this.props.event.list_event.filter((data)=>{
            return data.webEvent.categoryId===1||data.webEvent.categoryId===2
        })
        new_event=only_event.filter((data)=>{
        
            if(date==null){
                // alert('heu')
                if(category==0&&location==0){
                    return true
                }else if(category!==0&&location==0){
                    return data.webEvent.categoryId===category&&true
                }else if(category==0&&location!==0){
                    return true&&data.webEvent.locationId===location
                }else{
                    return data.webEvent.categoryId===category&&data.webEvent.locationId===location
                }
                
            }else{
                let isBetwen=moment(data.webEvent.fromDate).isBetween(date.startDate,date.endDate)
                if(category==0&&location==0){
                    return true
                }else if(category!==0&&location==0){
                    return isBetwen&&data.webEvent.categoryId===category&&true
                }else if(category==0&&location!==0){
                    return isBetwen&&true&&data.webEvent.locationId===location
                }else{
                    return isBetwen&&data.webEvent.categoryId===category&&data.webEvent.locationId===location
                }
                
            }
            
        })

        this.setState({event:new_event,event_filter:false,is_event_filter:true})
        
        
    }
    onCloseEventFilter=()=>{
        this.setState({event_filter_list:{date:null,location:0,category:0},event_filter:false})
    }
    handleDisable=()=>{
        let {date,category,location}=this.state.event_filter_list
        if(category==null&&location==null){
            return true
        }else{
            return false
        }
    }
    eventFilter=()=>{
        
        return(
            <div>
                <DateRangePicker onCancel={this.onCancelEvent} onApply={this.onApplyEvent} initialSettings={{applyButtonClasses:'picker-btn',cancelButtonClasses:'picker-btn-cancel',drops:'down'}}>
                    <FormControl variant="outlined" size="small"  className='form-request'>
                        <InputLabel  htmlFor="companyName">Start date event</InputLabel>
                        <OutlinedInput
                            autoComplete='off'
                            id="companyName"
                            type='companyName'
                            name='companyName'
                            value={this.state.event_filter_list.date!==null?`${moment(this.state.event_filter_list.date.startDate).format('DD MMM YYYY')} - ${moment(this.state.event_filter_list.date.endDate).format('DD MMM YYYY')}`:'All Date'}
                            // onChange={this.onChange}
                            labelWidth={120}
                        />
                    </FormControl>
                </DateRangePicker>
                <br/><br/>
                <FormControl variant="outlined" size="small"  className='form-request'>
                    <InputLabel  htmlFor="name">Category Event</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={this.state.event_filter_list.category}
                        labelWidth={120}
                        onChange={(e)=>{this.setState({event_filter_list:{...this.state.event_filter_list,category:e.target.value}})}}
                    >
                        <MenuItem value={0}>All Category</MenuItem>
                        <MenuItem value={1}>Mega Seminar</MenuItem>
                        <MenuItem value={2}>Public Workshop</MenuItem>
                        {/* <MenuItem value={3}>Webinar</MenuItem> */}
                        <MenuItem value={4}>Blended Learning</MenuItem>
                    </Select>
                </FormControl>
                
                <br/><br/>  
                <FormControl variant="outlined" size="small"  className='form-request'>
                    <InputLabel  htmlFor="name">Location</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={this.state.event_filter_list.location}
                        labelWidth={60}
                        onChange={(e)=>{this.setState({event_filter_list:{...this.state.event_filter_list,location:e.target.value}})}}
                    >
                        <MenuItem value={0}>All Location</MenuItem>
                        <MenuItem value={1}>Jakarta</MenuItem>
                        <MenuItem value={2}>Medan</MenuItem>
                        <MenuItem value={3}>Surabaya</MenuItem>
                        <MenuItem value={4}>Makassar</MenuItem>
                        <MenuItem value={5}>Virtual</MenuItem>
                    </Select>
                </FormControl>
                <br/><br/>
                <Button disabled={this.handleDisable()} onClick={this.onSaveFilterEvent} style={{textTransform:'none',width:100}} size="small" color="primary" variant="contained">
                   Submit
                </Button>
            </div>
        )
    }
    children2=()=>{
        return(
            <div>
                <p>Thank you for your interest in One GML. we will contact you as soon as possible</p>
                <br/>
                <Button onClick={this.toggleSucces} style={{textTransform:'none',width:100}} size="small" color="primary" variant="contained">Ok</Button>
            </div>
        )
    }
    loader=()=>{
        return(
            <div className='loader-skeleton'>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>

            </div>
        )
    }
    loader2=()=>{
        return(
            <div className='loader-skeleton'>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>

            </div>
        )
    }
    
    onChangeWebinar=(e)=>{
        let {value}=e.target
        let new_webinar=[]
        this.state.webinar.map((data)=>{
            let include=data.webEvent.title.toLowerCase().includes(value.toLowerCase())
            if(include){
                new_webinar.push(data)
            }
        })
        if(value.length>0){
            this.setState({webinar:new_webinar,is_webinar_filter:true})
        }else{
            let only_webinar=this.props.event.list_event.filter((data)=>{
                return data.webEvent.categoryId!==1&&data.webEvent.categoryId!==2
            })
            this.setState({webinar:only_webinar,is_webinar_filter:true})
        }
        
    }
    onChangeEvent=(e)=>{
        let {value}=e.target
        let event=[]
        this.state.event.map((data)=>{
            let include=data.webEvent.title.toLowerCase().includes(value.toLowerCase())
            if(include){
                event.push(data)
            }
        })
        if(value.length>0){
            this.setState({event:event,is_event_filter:true})
        }else{
            let only_event=this.props.event.list_event.filter((data)=>{
                return data.webEvent.categoryId===1||data.webEvent.categoryId===2
            })
            this.setState({event:only_event,is_event_filter:true})
        }
        
    }
    renderCategory=()=>{
        let category=[
            {
                id:0,
                text:'All Category'
            },
            {
                id:1,
                text:'Mega Seminar'
            },
            {
                id:2,
                text:'Public Workshop'
            },
            {
                id:3,
                text:'Webinar'
            },
            {
                id:4,
                text:'Blended Learning'
            },
        ]
        if(this.state.event_filter_list.category!==null){
            let find=category.filter((data)=>{return data.id===this.state.event_filter_list.category})
            return find[0].text
        }else{
            return 'All Category'
        }
    }
    renderDate=()=>{
        if(this.state.event_filter_list.date!==null){
            return `${moment(this.state.event_filter_list.date.startDate).format('DD MMM YYYY')} - ${moment(this.state.event_filter_list.date.endDate).format('DD MMM YYYY')}`
        }else{
            return 'All Date'
        }
    }
    renderLocation=()=>{
        let location=[
            {
                id:0,
                text:'All Location'
            },
            {
                id:1,
                text:'Jakarta'
            },
            {
                id:2,
                text:'Medan'
            },
            {
                id:3,
                text:'Surabaya'
            },
            {
                id:4,
                text:'Makassar'
            },
            {
                id:5,
                text:'Virtual'
            },
        ]
        if(this.state.event_filter_list.location!==null){
            let find=location.filter((data)=>{return data.id===this.state.event_filter_list.location})
            return find[0].text
        }else{
            return 'All Location'
        }
    }
    render() {
        console.log(`this.state.event_filter_list`, this.state.event_filter_list)

        const {request_form,success_form,photoIndex, isOpen,webinar,event,event_filter,is_event_filter,is_webinar_filter }=this.state
        const {general}=this.props
        return (
            <div>
                {!this.state.timeout?
                <>
                <Navbar/>
                <br/><br/><br/><br/><br/>
                <Modal title="Download insight" isOpen={request_form} children={this.children()} modalToggle={this.toggleRequest}/>
                <Modal title="Request insight recorded" isOpen={success_form} children={this.children2()} modalToggle={this.toggleSucces}/>
                <ModalFilterEvent title="Filter Event" isOpen={event_filter} children={this.eventFilter()} modalToggle={this.onCloseEventFilter}/>
                <div className='margin-auto'>
                    <HeadPage title='Event & Webinar' subtitle='Join with us' is_filter={false}/>
                </div>
                <section className='event-page'  >
                    {webinar.length>0||is_webinar_filter?
                    <>
                    
                    <div id='webinar'>
                    {/* <Download toggleDownload={this.toggleRequest}/> */}
                
                    <br/>
                    
                    <Element name='webinar'>
                    <div className='head-event-page' >                        
                        <h1>Webinar</h1>
                        &nbsp;&nbsp;&nbsp;
                        <div style={{width:1,height:40,backgroundColor:'grey'}}></div>
                        &nbsp;&nbsp;&nbsp;
                        <p>Stay Productive in Crisis with Webinars</p>
                    </div>
                    </Element>
                    </div>
                    <br/>
                    <div className='filter-event'>
                        <div className='div-flex div-align-center' style={{flexWrap:'wrap'}}>
                            <h4 style={{color:'#464646',fontFamily:'Lato,sans-serif'}}>Browse by</h4>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <h4 style={{color:'#00a1ed',fontFamily:'Lato,sans-serif'}}>
                                {this.state.webinar_filter_date==null?'All Date':`${moment(this.state.webinar_filter_date.startDate).format('DD MMM YYYY')} - ${moment(this.state.webinar_filter_date.endDate).format('DD MMM YYYY')}`}
                            </h4>
                        </div>
                        <div>
                            <div className='div-flex div-align-center'>
                                <input onChange={this.onChangeWebinar} className='input-custom' placeholder="Search webinar name"/>
                                &nbsp;&nbsp;&nbsp;
                                <DateRangePicker
                                    initialSettings={{applyButtonClasses:'picker-btn',cancelButtonClasses:'picker-btn-cancel',}}
                                    onApply={this.onApply}
                                    onCancel={this.onCancelWebinar}
                                >
                                    <Button onClick={()=>null} color='primary' variant='contained' size='small' className='btn-remove-capital btn-rounded'>
                                        Filter
                                    </Button>
                                </DateRangePicker>
                                
                            </div>
                        </div>
                    </div>
                    <br />
                    <Grid3 data={webinar}/>
                    <br/><br />
                    </>:null}
                    <Element name='event'>

                    <div id='event'>
                    <br/><br /><br /><br /><br />
                    </div>
                    </Element>
                    {event.length>0||is_event_filter?
                    <>
                    <div className='event-header'>
                        <div style={{display:'flex',alignItems:'center'}}>
                            <h1>Event</h1>
                            &nbsp;&nbsp;&nbsp;
                            <div style={{width:1,height:40,backgroundColor:'grey'}}></div>
                            &nbsp;&nbsp;&nbsp;
                            <p>Join with us</p>
                        </div>
                        <div>
                        <Button onClick={()=>window.location.assign(`/event-plan/${moment().year()}`)} style={{textTransform:'none'}} size="small" color="primary" variant="contained">Public workshop in {moment().format('YYYY')}</Button>
                        </div>
                    </div>
                    <div className='event-header-mobile'>
                        <div style={{display:'flex',alignItems:'center'}}>
                            <h1>Event</h1>
                        </div>
                        <div>
                        <Button onClick={()=>window.location.assign(`/event-plan/${moment().year()}`)} style={{textTransform:'none',fontWeight:'bold'}} size="small" color="primary" variant="text">Public workshop in {moment().format('YYYY')}&nbsp;&nbsp;&nbsp;<img style={{width:9}} src={ChevronRight}/></Button>
                        </div>
                    </div>
                    <br/>
                    <div className='filter-event'>
                        <div className='div-flex div-align-center' style={{flexWrap:'wrap'}}>
                            <h4 style={{color:'#464646',fontFamily:'Lato,sans-serif'}}>Browse by</h4>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <h4 style={{color:'#00a1ed',fontFamily:'Lato,sans-serif'}}>{this.renderCategory()}</h4>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <div style={{width:1.2,height:25,backgroundColor:'#cccccc'}}></div>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <h4 style={{color:'#00a1ed',fontFamily:'Lato,sans-serif'}}>{this.renderDate()}</h4>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <div style={{width:1.2,height:25,backgroundColor:'#cccccc'}}></div>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <h4 style={{color:'#00a1ed',fontFamily:'Lato,sans-serif'}}>{this.renderLocation()}</h4>
                        </div>
                        <div>
                            <div className='div-flex div-align-center'>
                                <input onChange={this.onChangeEvent} className='input-custom' placeholder="Search webinar name"/>
                                &nbsp;&nbsp;&nbsp;
                                <Button onClick={()=>this.setState({event_filter:!this.state.event_filter})} color='primary' variant='contained' size='small' className='btn-remove-capital btn-rounded'>
                                    Filter
                                </Button>
                            </div>
                        </div>
                    </div>
                    </>
                     :null} 
                    <br/>
                    <Grid data={event}/>
                    <br/>
                    <hr/>
                </section>
               
                <Footer/>
                </>
                :
                <>
                <Navbar/>
                <br/><br/><br/><br/><br/>
                <Modal title="Download insight" isOpen={request_form} children={this.children()} modalToggle={this.toggleRequest}/>
                <Modal title="Request insight recorded" isOpen={success_form} children={this.children2()} modalToggle={this.toggleSucces}/>
                <div className='margin-auto'>
                <HeadPage title='Event & Webinar' subtitle='Join with us' is_filter={false}/>

                </div>
               
               
                <section className='event-page'  >
                    <div >
                    <Download toggleDownload={this.toggleRequest}/>
                
                    <br/>
                    {webinar.length>0&&
                    <div className='head-event-page' >                        
                        <h1>Webinar</h1>
                        &nbsp;&nbsp;&nbsp;
                        <div style={{width:1,height:40,backgroundColor:'grey'}}></div>
                        &nbsp;&nbsp;&nbsp;
                        <p>Stay Productive in Crisis with Webinars</p>
                    </div>
                    }
                    </div>
                    <br />
                    {this.loader()}
                    <br/><br />
                    
                    <div >
                    <br/><br /><br /><br /><br />
                    </div>
                    <div className='event-header'>
                        <div style={{display:'flex',alignItems:'center'}}>
                            <h1>Event</h1>
                            &nbsp;&nbsp;&nbsp;
                            <div style={{width:1,height:40,backgroundColor:'grey'}}></div>
                            &nbsp;&nbsp;&nbsp;
                            <p>Join with us</p>
                        </div>
                        <div>
                        <Button onClick={()=>window.location.assign('/event-plan')} style={{textTransform:'none'}} size="small" color="primary" variant="contained">Public workshop in {moment().format('YYYY')}</Button>
                        </div>
                    </div>
                    <div className='event-header-mobile'>
                        <div style={{display:'flex',alignItems:'center'}}>
                            <h1>Event</h1>
                        </div>
                        <div>
                        <Button onClick={()=>window.location.assign('/event-plan')} style={{textTransform:'none',fontWeight:'bold'}} size="small" color="primary" variant="text">Public workshop in {moment().format('YYYY')}&nbsp;&nbsp;&nbsp;<img style={{width:9}} src={ChevronRight}/></Button>
                        </div>
                    </div>
                    <br/>
                   
                    {this.loader2()}
                    <br/>
                    <hr/>
                </section>
               
                <Footer/>
                </>
                }
            </div>
        )
    }
}
const mapStateToProps=(state)=>({
    general:state.general,
    event:state.event
})
const mapDispatchToProps={
    getEvent
}
export default connect(mapStateToProps,mapDispatchToProps)(index)